import React from "react";
import type { FeatureFlags } from "../../contexts/feature-flags";
import { useAppContext } from "../../hooks/useAppContext";
import { List } from "../list";
import { FeatureListItem } from "./feature-list-item";

import "./feature-list.css";

export const FeatureList = () => {
	const { featureManager } = useAppContext();

	return (
		<List className="feature-list">
			{Object.keys(featureManager.toggles)
				.filter((key) => !key.startsWith("debug"))
				.sort()
				.map((toggle) => {
					const value = featureManager.getFeatureFlagAsString(
						toggle as keyof FeatureFlags,
						"no value",
					);
					return (
						<FeatureListItem
							key={toggle}
							featureKey={toggle as keyof FeatureFlags}
							value={value}
							onSave={(key: keyof FeatureFlags, newValue) =>
								featureManager.setFeatureFlag(key, newValue)
							}
						/>
					);
				})}
			{Object.keys(featureManager.toggles)
				.filter((key) => key.startsWith("debug"))
				.sort()
				.map((toggle) => {
					const value = featureManager.getFeatureFlagAsString(
						toggle as keyof FeatureFlags,
						"no value",
					);
					return (
						<FeatureListItem
							debug
							key={toggle}
							featureKey={toggle as keyof FeatureFlags}
							value={value}
							onSave={(key: keyof FeatureFlags, newValue) =>
								featureManager.setFeatureFlag(key, newValue)
							}
						/>
					);
				})}
		</List>
	);
};
FeatureList.displayName = "FeatureListContainer";
